import React from "react";
import Language from "../components/common/languages";

const LanguagesPage = () => {
  return <Language />;
};

export default LanguagesPage;